import { inject, injectable } from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import System from "../system/System";
import SystemConfig from "../system/SystemConfig";
import BaseDOM from "../ui/BaseDOM";
import MadnesIframe from "../ui/components/MadnesIframe";
import IInfoPages from "./IInfoPages";

@injectable()
export default abstract class AbstractIframePage implements IInfoPages {
	protected opened: boolean = false;
	protected created: boolean = false;
	protected iframe: MadnesIframe | undefined = undefined;
	protected initialized = false;
	protected abstract appName: string;

	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) protected config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.DOM) protected DOM: BaseDOM,
		@inject(SERVICE_IDENTIFIER.System) protected system: System
	) {}

	create() {
		if (this.created) return;
		this.created = true;
		this.iframe = new MadnesIframe({
			parent: this.DOM.getWrapper(),
			systemConfig: this.config,
			appName: this.appName,
		});
		this.iframe.create();
	}
	isOpen(): boolean {
		return this.opened;
	}
	async open(): Promise<boolean> {
		if (!this.created) this.create();
		this.opened = true;
		this.iframe?.openIframe();

		return true;
	}
	async close(): Promise<boolean> {
		this.iframe?.close();

		this.opened = false;
		return true;
	}
	toggle(): Promise<boolean> {
		return this.isOpen() ? this.close() : this.open();
	}

	onRoundStart(): void {}
	async next(): Promise<any> {}
	async prev(): Promise<any> {}
	async home(): Promise<any> {}
	async arrow(data: any): Promise<any> {}
	onStartRound(): void {}
	onBetChange() {}
	init() {}
}
